import React, { useEffect, useState } from "react";
import { Select, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { useLocation } from "react-router-dom";

const MultiSelectWithCheckbox = ({
  options,
  type,
  selectedValues,
  onChange,
  fieldName,
  apiResponse,
  disabledValues = [],
}) => {
  const [internalSelectedValues, setInternalSelectedValues] = useState(
    Array.isArray(selectedValues) ? selectedValues : []
  );

  const location = useLocation()

  const BatchSelectData = location?.state?.autoBatchSelect

  // Automatically check batch when batch_type exists in options
  
  useEffect(() => {
    if(BatchSelectData)
    if (type === "batch_no") {
      const autoSelectedBatches = options
        .filter((option) => option.batch_type)
        .map((option) => option.batch);
  
      // ✅ Update selection only if user hasn't modified it manually
      setInternalSelectedValues((prevValues) =>
        prevValues.length > 0 ? prevValues : autoSelectedBatches
      );
      onChange({ target: { value: autoSelectedBatches } });
  
    } else {
      const autoSelectedOperators = options
        .filter((option) => option.operator_name)
        .map((option) => option.operator_name);
  
      if (autoSelectedOperators.length === 1) {
        setInternalSelectedValues((prevValues) =>
          prevValues.length > 0 ? prevValues : autoSelectedOperators
        );
        onChange({ target: { value: autoSelectedOperators } });
      }
    }
  }, [options, type]); // ✅ Only update if options change, but preserve manual selections
  

  const handleChange = (event) => {
    const { value } = event.target;
  
    if (type === "operator_name") {
      if (value.length > 0) {
        const latestSelectedValue = value[value.length - 1]; // Get the last selected value
        localStorage.setItem("operatorNameData",latestSelectedValue)
        console.log("Selected Operator:", latestSelectedValue);
  
        setInternalSelectedValues([latestSelectedValue]); 
        onChange({ target: { value: [latestSelectedValue] } }); 
      } else {
        // Handle case where all selections are removed
        setInternalSelectedValues([]);
        onChange({ target: { value: [] } });
      }
    } else {
      // Allow multiple selections for batch_no
      setInternalSelectedValues(value);
      onChange(event);
      localStorage.setItem("batchIdData", JSON.stringify(value));
      console.log("Batch Selection Changed:", );
    }
  };
  
  

  return (
    <Select
      multiple
      value={internalSelectedValues}
      onChange={handleChange}
      fullWidth
      size="small"
      variant="filled"
      name={fieldName}
      className="production-line-popup-input-field-data"
      sx={{
        backgroundColor: "#f0f0f0",
        "&:hover": { backgroundColor: "#e0e0e0" },
        "& .MuiFilledInput-root": {
          backgroundColor: "#f0f0f0",
        },
      }}
      renderValue={(selected) => {
        return selected
          .map((value) =>
            type === "batch_no"
              ? options.find((option) => option.batch === value)?.batch_type
              : options.find((option) => option.operator_name === value)?.operator_name
          )
          .filter(Boolean) // ✅ Remove undefined values
          .join(", "); // ✅ Prevent leading/trailing commas
      }}
    >
      {options.map((option) => (
       <MenuItem
       key={type === "batch_no" ? option.batch : option.operator_name } 
       value={type === "batch_no" ? option.batch : option.operator_name} // ✅ Use correct property
     
          disabled={disabledValues.includes(
            type === "batch_no" ? option.batch : option.operator_name
          )}
          sx={{ padding: "0px 8px", minHeight: "unset" }}
        >
         <Checkbox
  checked={internalSelectedValues.includes(
    type === "batch_no" ? option.batch : option.operator_name // ✅ Correct
  )}
/>

          <ListItemText
            primary={
              type === "batch_no" ? option.batch_type : option.operator_name
            }
          />
        </MenuItem>
      ))}
    </Select>
  );
};

export default MultiSelectWithCheckbox;
